export default class AppearAnimation {
    static init() {
        document.querySelectorAll('[data-index]').forEach((element) => {
            if (element.classList.contains('appear-anim-block')) {
                return;
            }
            element.classList.add('appear-anim-block');
            const index = (element.dataset.index % 5) + 1;
            element.style.animationDelay = `${index * 0.4}s`;
        });
    }

    static bindLivewire() {
        window.addEventListener('infinite-scroll:loaded', () => {
            this.init();
        });
    }
}
